<template>
  <div class="active">
    <div class="activetitle">{{activeinfo.title}}</div>
    <div class="mb-100">
      <van-cell-group>
        <div class="box">
          <span class="titlename">您的姓名</span>
        </div>
        <van-field v-model="params.name" placeholder="填写姓名" />
      </van-cell-group>
      <van-cell-group>
        <div class="box">
          <span class="titlename">您的手机号</span>
        </div>
        <van-field v-model="params.mobile" placeholder="填写手机号" maxlength='11' type='tel' />
      </van-cell-group>
      <van-cell-group>
        <div class="box">
          <span class="titlename">您的性别</span>
        </div>
        <van-radio-group v-model="params.sex">
          <van-radio name="1" checked-color="#605C6B">男</van-radio>
          <van-radio name="2" checked-color="#605C6B">女</van-radio>
        </van-radio-group>
      </van-cell-group>
      <van-cell-group>
        <div class="box">
          <span class="titlename">您的地区</span>
        </div>
        <van-field v-model="params.city" placeholder="地区" />
      </van-cell-group>
      <van-cell-group>
        <div class="box">
          <span class="titlename">成人数</span>
        </div>
        <van-field v-model="params.man_num" type='number' placeholder="填写数字"  />
      </van-cell-group>
      <van-cell-group>
        <div class="box">
          <span class="titlename">是否有儿童</span>
        </div>
        <van-radio-group v-model="params.is_child">
          <van-radio name="1" checked-color="#605C6B">有儿童</van-radio>
          <van-radio name="0" checked-color="#605C6B">没有儿童</van-radio>
        </van-radio-group>
      </van-cell-group>
      <van-cell-group v-if="params.is_child==1">
        <div class="box">
          <span class="titlename">儿童数</span>
        </div>
        <van-field v-model="params.child_num" type='number' placeholder="填写数字" />
      </van-cell-group>
      <van-cell-group v-if="params.is_child==1">
        <div class="box">
          <span class="titlename">儿童年龄</span>
        </div>
        <van-field v-model="params.child_age" type='number' placeholder="儿童年龄" />
      </van-cell-group>
      <van-cell-group>
        <div class="box">
          <span class="titlename">前往方式</span>
        </div>
        <van-radio-group v-model="params.vehicle_type">
          <van-radio name="1" checked-color="#605C6B">自驾</van-radio>
          <van-radio name="0" checked-color="#605C6B">其他</van-radio>
        </van-radio-group>
      </van-cell-group>
      <van-cell-group v-if="params.vehicle_type==1">
        <div class="box">
          <span class="titlename">车牌号</span>
        </div>
        <van-field v-model="params.car_number" placeholder="例：京A 12345" />
      </van-cell-group>
      <van-cell-group v-if="params.vehicle_type==1">
        <div class="box">
          <span class="titlename">车型信息</span>
        </div>
        <van-field readonly clickable v-model="params.car_model_name" placeholder="选择车型信息" @click="showPicker = true" />
      </van-cell-group>
      <van-cell-group>
        <div class="box">
          <span class="titlename">时间</span>
        </div>
        <van-field readonly clickable v-model="params.time" :value="params.time" @click="showPickertime = true" placeholder="选择时间" />
      </van-cell-group>
    </div>
    <div class="btn-box">
      <!-- <van-button color="#605C6B" size="large" @click="saveInfo">确认提交</van-button> -->
      <van-button color="#605C6B" size="large" @click="saveInfo" v-if="source==6||source==8||source==9">确认提交</van-button>
      <van-button color="#1F2A74" style="border-radius: 6px;" size="large" @click="saveInfo" v-if="source==5">确认提交</van-button>
      <van-button color="#AA0000" size="large" @click="saveInfo" v-if="source==12">确认提交</van-button>
      <van-button color="#FFBB00" style="border-radius: 6px;" size="large" @click="saveInfo" v-if="source==1||source==3||source==4||source==7||source==11">确认提交</van-button>
    </div>
    <van-popup v-model="showPicker" position="bottom">
      <van-picker
      title=""
      show-toolbar
      :columns="columns"
      @confirm="onConfirm"
      @cancel="onCancel"
      @change="onChange"
      />
    </van-popup>
    <van-popup v-model="showPickertime" position="bottom">
      <van-datetime-picker
      type="datehour"
      :min-date='minDate'
      :max-date="maxDate"
      @confirm="onConfirmtime"
      @cancel="showPickertime = false"
      />
    </van-popup>
  </div>

</template>
<script>
  import active from '../../../api/lexus/active';
  import list from '../../../api/member/mycars';
  import common from '../../../api/common';
  import {Field,Button,RadioGroup,Radio,Cell, CellGroup,Picker,Popup,DatetimePicker } from 'vant';
  export default {
    data () {
      return {
        id:'',
        params:{
          hid:'',
          name:'',
          mobile:'',
          sex:1,
          man_num:'',
          time:'',
          is_child:'',
          child_num:'',
          child_age:'',
          city:'',
          car_number:'',
          is_drive:1,
          car_model_id:'',
          car_model_name:'',
          other: ''
        },
        showPickertime:false,
        showPicker:false,
        columns: [],
        again:0,
        activeinfo:'',
        minDate:'',
        maxDate:''
      }
    },
    created () {
      this.$store.commit('param/show', false)
      this.$appService.isShowReturn({state: true})
      this.$appService.isTabbar({state: true})
      var apppar={
        title:this.$route.meta.title
      }
      this.$appService.changeTitle(apppar)
      // this.getCars()
      if(Lockr.get('token')){
        this.$store.dispatch('param/setToken', Lockr.get('token'))
        this.userinfo=Lockr.get('user')
        this.params.mobile=Lockr.get('user').mobile
      }else{
        this.getAuthorization.getAuthorization();
      }

      if(this.$route.query.id){
        this.params.hid = this.$route.query.id
        this.source = this.$route.query.source
        this.getActivity(this.$route.query.id)
        this.getCars()
      }
      // if(this.$route.query.token){
      //   this.id = this.$route.query.id
      //   this.source = this.$route.query.source
      //   this.token = this.$route.query.token
      //   this.user_id = this.$route.query.userid
      //   this.$store.dispatch('param/setToken', this.$route.query.token)
      //   this.getActivity(this.$route.query.userid)
      // }else if(this.$route.params.token){
      //   this.id = this.$route.query.id
      //   this.source = this.$route.params.source
      //   this.token = this.$route.params.token
      //   this.$store.dispatch('param/setToken', this.token)
      //   this.user_id = this.$route.params.user_id
      //   this.again=this.$route.params.again
      //   this.getActivity(this.$route.params.user_id)
      // }
    },
    methods: {
      getCars(){
        var params={
          brand_id:1,
          region:1
        }
        list.getCars(params).then(res => {
          if(res.data.state == 1) {
            var lists=res.data.data
            var columns =[]
            for (let i in lists) {
              var params={
                text:lists[i].title,
                id:lists[i].id
              }
              columns.push(params); 
            }
            this.columns=columns

          }
        })
      },
      getActivity(id){
        var params={
          user_id:this.user_id,
        }
        common.getActivity(params,id).then(res => {
          if(res.data.state==1){
            this.activeinfo=res.data.data
            this.minDate=new Date(res.data.data.start.substring(0,4),res.data.data.start.substring(5,7)-1,res.data.data.start.substring(8,10),res.data.data.start.substring(11,13))
            this.maxDate=new Date(res.data.data.end.substring(0,4),res.data.data.end.substring(5,7)-1,res.data.data.end.substring(8,10),res.data.data.end.substring(11,13))
            var params={
              event_code: '活动邀请',
              event_id: res.data.data.id,
              title: res.data.data.title,
              value: '',
              path: '/Motortime/Active/Active.vue',
              user_id: this.user_id ? this.user_id : 0,
              source: this.source
            }
            common.BurialPoint(params).then(res => {
              if(res.data.state==1){

              }
            })
          }
        })
      },
      
      saveInfo(){
        if(this.params.name==''){
          this.$toast('请填写您的姓名');
          return false
        }else if(this.params.mobile==''){
          this.$toast('请填写您的手机号');
          return false
        }else if(!(/^1[3456789]\d{9}$/.test(this.params.mobile))){
          this.$toast('请填写正确的手机号');
          return false
        }else if(this.params.man_num==''){
          this.$toast('请填写成人人数');
          return false
        }
        

        common.activeApplyAll(this.params).then(res => {
          if(res.data.state==1){
             // this.$router.push({name:'LexusActiveok',params:{source:this.source,token:this.token,user_id:this.user_id}});
             // wx.miniProgram.reLaunch({url: '/pages/webview/webview?scene=https://m.motortime.com/lexus/active/activeok'})
             var params={
              name:'',
              mobile:'',
              sex:1,
              man_num:'',
              time:'',
              is_child:'',
              child_num:'',
              child_age:'',
              city:'',
              car_number:'',
              is_drive:1,
              car_model_id:'',
              car_model_name:'',
              other: ''
            }
            this.params=params

            this.$dialog.alert({
              title: '温馨提示',
              message: '您已报名，感谢您的参与！'
              // 具体细节我们将通过“GR FANS 服务区“微信号与您联系，
            })
          } else {
            this.$toast('报名失败');
            return false
          }
        })
      },
      onConfirm(value, index) {
        this.showPicker=false
        this.params.car_model_name=value.text
        this.params.car_model_id=value.id
        // Toast(`当前值：${value}, 当前索引：${index}`);
      },
      onConfirmtime(time) {
        var Y = time.getFullYear();
        var M = time.getMonth() + 1;
        M = M < 10 ? '0' + M : M;
        var D = time.getDate();
        D = D < 10 ? '0' + D : D;
        var H = time.getHours();
        H = H < 10 ? '0' + H : H;
        var Mi = time.getMinutes();
        Mi = Mi < 10 ? '0' + Mi : Mi;
        var S = time.getSeconds();
        S = S < 10 ? '0' + S : S;

        this.params.time = Y + '-' + M + '-' + D + ' ' + H + ':' + Mi + ':' + S;
        this.showPickertime = false;

      },
      onChange(picker, value, index) {
        // Toast(`当前值：${value}, 当前索引：${index}`);
      },
      onCancel() {
        // Toast('取消');
      },
    },
    components: {
      [RadioGroup.name]: RadioGroup,
      [Radio.name]: Radio,
      [Field.name]:Field,
      [Button.name]:Button,
      [Cell.name]: Cell,
      [CellGroup.name]:CellGroup,
      [Picker.name]:Picker,
      [Popup.name]:Popup,
      [DatetimePicker.name]:DatetimePicker
    }
  }
</script>
<style lang="scss">
.active{
  .activetitle{
    font-size: 16px;
    text-align: center;
    margin: 30px 0;
    font-weight: bold;
  }
  .van-cell-group{
    padding: 5px 0;
  }
  .box{
    margin-left: 15px;
    .titlenum{
      font-size: 20px;
      font-weight: bold;
      color: #3A3A3A;
    }
    .titlename{
      font-size: 14px;
      color: #3A3A3A;
    }
  }
  .van-radio-group{
    display: flex;
    padding: 10px 15px;
  }
  .van-radio{
    margin-right: 40px;
    .van-radio__label{
      font-size: 14px;
    }
  }
  .btn-box{
    width: 100%;
    bottom: 20px;
    position: fixed;
    text-align: center;
    -webkit-user-select: none;/*禁用手机浏览器的用户选择功能 */
    -moz-user-select: none;
    -webkit-touch-callout: none;
    -ms-user-select:none; /*IE10*/
    user-select:none;
    .van-button--large{
      width: 90%;
    }
  }
  .mb-100{
    margin-bottom: 100px;
  }
  .mb-240{
    margin-bottom: 240px;
  }

}
</style>
